import { GridSortDirection } from "@mui/x-data-grid";

export interface Result<T> {
  data: T | null;
  isSuccess: boolean;
  errors: string[];
}
export class Result<T> {
  data: T | null;
  isSuccess: boolean;
  errors: string[];

  constructor(result: Result<T>) {
    this.data = result.data;
    this.isSuccess = result.isSuccess;
    this.errors = result.errors;
  }
  static newResult = () =>
    new Result({ data: null, isSuccess: true, errors: [] });
}

export interface SortParameter {
  field: string;
  sort: GridSortDirection;
}

export interface PagedResponse<T> extends Result<Array<T>> {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  readonly hasPrevious: boolean;
  readonly hasNext: boolean;
  sort?: SortParameter;
}
